import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Printer, Image as ImageIcon, Zap } from 'lucide-react';
export function MirrorReveal() {
  return <section id="servicio" className="py-20 md:py-32 bg-ink relative overflow-hidden" data-id="element-361">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-362">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-363">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-364">
            <div data-id="element-365">
              <h3 className="font-script text-3xl md:text-4xl text-gold mb-2" data-id="element-366">
                Permítenos presentarte algo diferente.
              </h3>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-cream leading-tight mb-6" data-id="element-367">
                Algo que está cambiando la forma en que las familias hispanas en
                Atlanta celebran.
              </h2>
            </div>

            <p className="text-2xl font-medium text-gold" data-id="element-368">
              El Mirror Photo Booth — nuestro Espejo de los Recuerdos Eternos.
            </p>

            <div className="space-y-4 text-lg text-cream/80 font-light" data-id="element-369">
              <p data-id="element-370">
                No es una cámara. No es un booth de cartón. No es tecnología
                genérica.
              </p>
              <p data-id="element-371">
                Es un espejo interactivo de lujo con iluminación LED
                cinematográfica, diseñado para ser el centro elegante de
                cualquier evento.
              </p>
              <p data-id="element-372">
                Tus invitados se acercan, tocan la pantalla, posan solos o en
                grupo — y en segundos tienen en sus manos una foto impresa de
                alta calidad, personalizada con el nombre de tu evento.
              </p>
            </div>

            <div className="bg-charcoal p-6 rounded-xl border border-gold/20 mt-8" data-id="element-373">
              <p className="text-xl text-cream font-medium mb-4" data-id="element-374">
                El resultado: cada persona se va a su casa con un recuerdo
                físico de tu celebración.
              </p>
              <ul className="space-y-2 text-cream/80 font-light" data-id="element-375">
                <li data-id="element-376">• La abuela que vino de lejos.</li>
                <li data-id="element-377">• El primo que viajó de otro estado.</li>
                <li data-id="element-378">• Los amigos que nunca olvidan una buena fiesta.</li>
              </ul>
              <p className="text-gold font-serif text-xl mt-4 italic" data-id="element-379">
                Todos se llevan un pedazo de tu historia.
              </p>
            </div>
          </motion.div>

          {/* Right Column: Illustration/Features */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-380">
            {/* Real Mirror Photo Booth Photo — blended into the dark area */}
            <div className="relative w-full max-w-md mx-auto aspect-[3/4] overflow-hidden" data-id="element-381">
              {/* Ambient gold glow behind the booth */}
              <div className="absolute inset-0 bg-gold/10 blur-[80px] rounded-full pointer-events-none" data-id="element-382"></div>

              <div className="relative w-full h-full" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 75% 80% at 55% 55%, black 45%, transparent 95%)',
              maskImage: 'radial-gradient(ellipse 75% 80% at 55% 55%, black 45%, transparent 95%)'
            }} data-id="element-383">
                <img src="https://cdn.magicpatterns.com/uploads/nN5p4oKu2NHmAQezQMTVHT/photobooth_1.png" alt="Mirror Photo Booth de lujo — equipo real" className="w-full h-full object-cover scale-[1.45]" style={{
                objectPosition: '78% 62%'
              }} data-id="element-384" />
              </div>
              {/* Soft dark vignette to fully merge with the page background */}
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent pointer-events-none" data-id="element-385"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-ink/30 pointer-events-none" data-id="element-386"></div>
            </div>

            {/* Feature Callouts */}
            <div className="absolute -right-4 top-1/4 bg-ink p-4 rounded-xl border border-gold/30 shadow-xl max-w-[200px] hidden md:block" data-id="element-387">
              <div className="flex items-center gap-3 mb-2" data-id="element-388">
                <Zap className="w-5 h-5 text-gold" data-id="element-389" />
                <span className="font-semibold text-cream text-sm" data-id="element-390">
                  Interactivo
                </span>
              </div>
              <p className="text-xs text-cream/70" data-id="element-391">
                Pantalla táctil completa con animaciones
              </p>
            </div>

            <div className="absolute -left-8 bottom-1/4 bg-ink p-4 rounded-xl border border-gold/30 shadow-xl max-w-[200px] hidden md:block" data-id="element-392">
              <div className="flex items-center gap-3 mb-2" data-id="element-393">
                <Printer className="w-5 h-5 text-gold" data-id="element-394" />
                <span className="font-semibold text-cream text-sm" data-id="element-395">
                  Al Instante
                </span>
              </div>
              <p className="text-xs text-cream/70" data-id="element-396">
                Impresión profesional en segundos
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}